/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_04b53ad4"]'><div :class='["checkbox-group-square-selected-demo"]'><div :class='["cube-checkbox-group-example"]'><cube-checkbox-group :options="(options)" shape="square" :inline="(true)" :values="checkedValues" mpxModelEvent="input" @mpxModel='(e)=>__invoke(e, [["__model","checkedValues", "__mpx_event__", ["value"], undefined]])'></cube-checkbox-group></div><div :class='["view-desc"]'>checked values：{{ checkedValues }}</div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_04b53ad4"}'>
.cube-checkbox-example
  padding 5px 10px
  background-color #fff
.desc
  margin-top 15px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_04b53ad4"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_04b53ad4"}
  /** script content **/
  require("./square-selected.mpx.js?isComponent&outputPath=components%2Fsquare-selected04b53ad4%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./square-selected.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fsquare-selected04b53ad4%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_04b53ad4"],
    ctorType: "component",
    outputPath: "components/square-selected04b53ad4/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-checkbox-group':getComponent(require("../../../packages/mpx-cube-ui/src/components/checkbox-group/index.mpx?isComponent&outputPath=components%2Findexc8b9c288%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>